import SearchButtons from "components/SearchButtons";
import React, { useState } from "react";
import {
  Button,
  ButtonGroup,
  Dropdown,
  DropdownToggle,
  Offcanvas,
  OffcanvasBody,
} from "reactstrap";
import columnSelectorIcon from "../../../../assets/icon/column-selector.svg";
import CloseIcon from "../../../../assets/icon/chatClose.svg";

import ReactStrapTable from "components/reactStrapTable";
import Checkbox from "components/common/Fields/Checkbox";
import UpdateOnHand from "../UpdateOnHand";

const CycleCountPage = () => {
  const [editDetails, setEditDetails] = useState(false);
   const [tableData, setTableData] = useState(rowData);
      const [data, setData] = useState([]);
  const columnData = [
    {
      dataField: "all",
      text: (
        <div className="d-flex justify-content-flexstart align-items-center gap-2">
          <Checkbox />
          All
        </div>
      ),
      show: true,
      width: 50,
    },
    {
      dataField: "drugname",
      text: "Drug Name",
      show: true,
      sort: true,
      width: 200,
    },

    {
      dataField: "ndc",
      text: "NDC",
      show: true,
      sort: true,
    },
    {
      dataField: "manufacturer",
      text: "Manufacturer",
      show: true,
      sort: true,
      width: 140,
    },
    {
      dataField: "packagesize",
      text: "Package Size",
      show: true,
      sort: true,
      width: 130,
    },
    // {
    //   dataField: "packageprice",
    //   text: "Package Price",
    //   show: true,
    //   sort: true,
    //   width: 140,
    // },
    {
      dataField: "qtyonhand",
      text: "Qty On Hand",
      show: true,
      sort: true,
      width: 130,
    },
    {
      dataField: "lastcount",
      text: "Last Count",
      show: true,
      sort: true,
      width: 120,
    },
  ];

  const rowData = [
    {
      all: <Checkbox />,
      drugname: "Valsartan 160 MG Tablet",
      ndc: "34981319899",
      manufacturer: "Lupin",
      packagesize: "100 EA/BTL",
      // packageprice: "284",
      qtyonhand: "284",
      lastcount: "11/20/2024",
    },
    {
      all: <Checkbox />,
      drugname: "Levothyroxine 50MCG Tab",
      ndc: "00378129010",
      manufacturer: "Mylan",
      packagesize: "1000 EA/BTL",
      // packageprice: "$ 24.95",
      qtyonhand: "2450",
      lastcount: "10/22/2024",
    },
    {
      all: <Checkbox />,
      drugname: "Amoxicillin 400MG/5ML Susp",
      ndc: "00093724073",
      manufacturer: "Teva",
      packagesize: "100 ML/BTL",
      // packageprice: "$ 24.95",
      qtyonhand: "875",
      lastcount: "11/5/2024",
    },
    {
      all: <Checkbox />,
      drugname: "Metformin 500MG Tab",
      ndc: "65162017550",
      manufacturer: "Amneal",
      packagesize: "500 EA/BTL",
      // packageprice: "$ 24.95",
      qtyonhand: "1275",
      lastcount: "9/30/2024",
    },
    {
      all: <Checkbox />,
      drugname: "Alprazolam 0.5MG Tab",
      ndc: "00228202811",
      manufacturer: "Actavis",
      packagesize: "100 EA/BTL",
      // packageprice: "$ 24.95",
      qtyonhand: "184",
      lastcount: "12/15/2024",
    },
    {
      all: <Checkbox />,
      drugname: "Valsartan 160 MG Tablet",
      ndc: "1234567890",
      manufacturer: "Amneal",
      packagesize: "500 EA/BTL",
      // packageprice: "$ 24.95",
      qtyonhand: "284",
      lastcount: "11/20/2024",
    },
    {
      all: <Checkbox />,
      drugname: "Valsartan 160 MG Tablet",
      ndc: "1234567890",
      manufacturer: "Amneal",
      packagesize: "500 EA/BTL",
      // packageprice: "$ 24.95",
      qtyonhand: "284",
      lastcount: "11/20/2024",
    },
    {
      all: <Checkbox />,
      drugname: "Valsartan 160 MG Tablet",
      ndc: "1234567890",
      manufacturer: "Amneal",
      packagesize: "500 EA/BTL",
      // packageprice: "$ 24.95",
      qtyonhand: "284",
      lastcount: "11/20/2024",
    },
    {
      all: <Checkbox />,
      drugname: "Valsartan 160 MG Tablet",
      ndc: "1234567890",
      manufacturer: "Amneal",
      packagesize: "500 EA/BTL",
      // packageprice: "$ 24.95",
      qtyonhand: "284",
      lastcount: "11/20/2024",
    },
    {
      all: <Checkbox />,
      drugname: "Valsartan 160 MG Tablet",
      ndc: "1234567890",
      manufacturer: "Amneal",
      packagesize: "500 EA/BTL",
      // packageprice: "$ 24.95",
      qtyonhand: "284",
      lastcount: "11/20/2024",
    },
  
  ];

  return (
    <div className="table-card scroll-table position-relative layout-alignment border-0 p-3 pb-0 rounded bg-white">
      <div className="heading-text section-devider-border pb-2 mb-1">
        Cycle Count Queue
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "8px",
        }}
      >
        <div style={{ display: "flex", gap: "12px" }}>
          <div>
            <SearchButtons
              InSize={200}
              placeHolder={"Search by Drug Name"}
              data={data}
              setFilterData={setTableData}
            />
          </div>
          <div>
            <Dropdown isOpen={undefined} toggle={undefined}>
              <DropdownToggle className="clmn">
                <img src={columnSelectorIcon} alt="not available" />
                <span>
                  Columns{" "}
                  {/* {totalCount > 0 && (
                                    <div className="totalcount">{totalCount}</div>
                                  )} */}
                </span>
              </DropdownToggle>
            </Dropdown>
          </div>
        </div>
        <div className="d-flex">
          <Button color="" style={{ color: "#702C62" }}>
            Settings
          </Button>
          <Button className="back-button">CS Audit</Button>
          <Button color="primary" onClick={() => setEditDetails(!editDetails)}>
            Manual Count
          </Button>
        </div>
      </div>
      <div fixed-height={rowData.length > 0 ? "fixed-height" : "default"}>
        <ReactStrapTable
          id="cyclecounts"
          data={rowData}
          columns={columnData}
          height={550}
          width={1200}
        />
      </div>
      <div>
        <Offcanvas
          direction="end"
          isOpen={editDetails}
          toggle={() => setEditDetails(!editDetails)}
        >
          <div className="casvas-header p-3 pb-1">
            <div>Update on Hand</div>
            <div
              className="cursor-pointer"
              onClick={() => setEditDetails(!editDetails)}
            >
              <img src={CloseIcon} />
            </div>
          </div>
          <div className="section-devider-border-popup"></div>
          <OffcanvasBody className="p-3 pt-1">
            <UpdateOnHand />
          </OffcanvasBody>
          <div className="footer-btns justify-content-end">
            <div className="d-flex">
              <Button>Back</Button>
              <Button color="primary">Save</Button>
            </div>
          </div>
        </Offcanvas>
      </div>
    </div>
  );
};

export default CycleCountPage;
